/**
 * Maps tenant app paths to capability route keys from GET /api/tenant/capabilities.
 * Only paths that require module entitlements are listed; unlisted paths are always allowed.
 */
const EXACT_ROUTE_ENTITLEMENTS: Record<string, string> = {
  '/operations/wafer-id-acquire': 'waferIdAcquire',
  '/operations/wafer-data-refresh': 'waferDataRefresh',
  '/operations/audit-runs': 'audits',
  '/operations/audit-workflow': 'audits',
  '/operations/conflicts': 'conflictResolution',
  '/location': 'nodeCommandCenter',
  '/location/overview': 'spatialOverview',
  '/location/tag-fleet': 'nodeFleetHealth',
  '/location/anchor-health': 'satelliteHealth',
  '/location/history': 'nodeCommandCenter',
  '/location/alarms': 'nodeCommandCenter',
  '/location/tags': 'nodeCommandCenter',
  '/admin/location/floor-plans': 'cleanroomLayout',
  '/devices/efem-setup': 'axonSetup',
  '/devices/scan-templates': 'scanTemplates',
};

const PREFIX_ROUTE_ENTITLEMENTS: Array<{ prefix: string; key: string }> = [
  { prefix: '/devices/efem-setup/', key: 'axonSetup' },
];

export function resolveRouteCapabilityKey(cleanPath: string): string | null {
  const exact = EXACT_ROUTE_ENTITLEMENTS[cleanPath];
  if (exact) {
    return exact;
  }

  for (const { prefix, key } of PREFIX_ROUTE_ENTITLEMENTS) {
    if (cleanPath.startsWith(prefix)) {
      return key;
    }
  }

  const auditRunDetailMatch = cleanPath.match(/^\/operations\/audit-runs\/[^/]+$/);
  if (auditRunDetailMatch) {
    return 'audits';
  }

  return null;
}

const ROUTE_DISPLAY_LABELS: Record<string, string> = {
  waferIdAcquire: 'Wafer ID Acquire',
  waferDataRefresh: 'Wafer Data Refresh',
  audits: 'Audits',
  conflictResolution: 'Conflict Resolution',
  nodeCommandCenter: 'Node Command Center',
  spatialOverview: 'Spatial Overview',
  nodeFleetHealth: 'Node Fleet Health',
  satelliteHealth: 'Satellite Health',
  cleanroomLayout: 'Cleanroom Layout',
  axonSetup: 'Axon Setup',
  scanTemplates: 'Scan Templates',
};

export function getRouteEntitlementLabel(routeKey: string): string {
  return ROUTE_DISPLAY_LABELS[routeKey] ?? 'This feature';
}
